import { Component, Injector, Input } from '@angular/core';
import { TableDummiesWidgetBaseComponent } from '../table-dummies-widget-base/table-dummies-widget-base';

/**
 * TableDummies1Full Widget
 */
@Component({
  selector: 'table-dummies1-full-widget',
  templateUrl: './table-dummies1-full-widget.component.html',
  styleUrls: ['../../common/css/general.scss', '../table-dummies-widget-base/table-dummies-widget-base.scss']
})
export class TableDummies1FullWidgetComponent extends TableDummiesWidgetBaseComponent {

  /**
   * Widget Guid
   */
  @Input() widgetGuid: string;

  /**
  * Constructor
  */
  constructor(injector: Injector) {
    super(injector, 'tableDummies1Full');
  }
}
